import type { JSX } from 'react'
import type { IButtonProps } from '../Button'

import { IconNames } from 'atoms/Icon/Icon.h'
import { COLOR, INDENTS } from 'vars/index'
import { Button } from '../Button'
import {
  ButtonBordersWidth,
  ButtonColors,
  ButtonCorners,
  ButtonFluid,
  ButtonFonts,
  ButtonIconSizes,
  IconPositions,
} from '../Button.h'

export interface IControlBackwardSecondaryOpacityDarkVerticalFluidProps extends IButtonProps {}

export const ControlBackwardSecondaryOpacityDarkVerticalFluid = ({
  icon = IconNames.angleLeft,
  iconPosition = IconPositions.Left,
  iconSize = ButtonIconSizes.medium,
  corners = ButtonCorners.CORNERS_10,
  paddings = [INDENTS.INDENT_20],
  colorDefault = ButtonColors.COLOR_PRIMARY,
  colorDisabled = ButtonColors.COLOR_DISABLED,
  backgroundColorDefault = COLOR.SURFACE_OPACITY_DARK_40,
  backgroundColorHovered = COLOR.SURFACE_OPACITY_DARK_70,
  backgroundColorPressed = COLOR.SURFACE_OPACITY_DARK_70,
  backgroundColorDisabled = COLOR.SURFACE_OPACITY_DARK_70,
  borderWidth = ButtonBordersWidth.BORDER_0,
  font = ButtonFonts.Button1,
  fluid = ButtonFluid.Vertical,

  ...rest
}: IControlBackwardSecondaryOpacityDarkVerticalFluidProps): JSX.Element => {
  return (
    <Button
      icon={icon}
      iconPosition={iconPosition}
      iconSize={iconSize}
      corners={corners}
      paddings={paddings}
      colorDefault={colorDefault}
      colorDisabled={colorDisabled}
      backgroundColorDefault={backgroundColorDefault}
      backgroundColorHovered={backgroundColorHovered}
      backgroundColorPressed={backgroundColorPressed}
      backgroundColorDisabled={backgroundColorDisabled}
      borderWidth={borderWidth}
      font={font}
      fluid={fluid}
      {...rest}
    />
  )
}
